
<align
  direction="flex-start"
  small-gap
  :class="['card-watchlist-details', { config: hasConfig, alert: hasAlert }]"
  @click.native="setupAlerts"
>
  <icon-button
    :icon="alertIcon"
    tooltip="Setup price alerts"
    @click="setupAlerts"
  />

  <div class="text">
    {{ alertText }}
  </div>
</align>
